import { SET_TRANSLATIONS, CLEAR_TRANSLATIONS } from "./actionTypes";

export const setTranslations = (payload: Record<string, any>) => ({ type: SET_TRANSLATIONS, payload });

export const clearTranslations = () => ({ type: CLEAR_TRANSLATIONS });